import jquery from 'jquery';
// angular looks for window.jQuery on load
// https://stackoverflow.com/a/38588237/1467394

(window as any).$ = (window as any).jQuery = jquery;
